(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-blog-posts"] && !Shopify.designMode) return;
  try {
    
class WoshBlogPosts extends HTMLElement {
  constructor() {
    super();
    this.carousel = this.querySelector('.wosh-fbp__carrusel');
    this.track = this.querySelector('.wosh-fbp__carrusel-track');
    this.slides = this.querySelectorAll('.wosh-fbp__carrusel-slide');
    this.prevBtn = this.querySelector('.wosh-fbp__carrusel-btn--prev');
    this.nextBtn = this.querySelector('.wosh-fbp__carrusel-btn--next');
    this.filterBtns = this.querySelectorAll('.wosh-fbp__filtro-btn');
    this.cards = this.querySelectorAll('.wosh-fbp__tarjeta');
    this.currentIndex = 0;
    this.isDragging = false;
    this.startX = 0;
    this.init();
  }
  init() {
    if (this.carousel && this.track && this.slides.length > 1) {
      this.initCarousel();
    }
    if (this.filterBtns.length > 0) {
      this.initFilters();
    }
  }
  initCarousel() {
    this.prevBtn?.addEventListener('click', () => this.slide('prev'));
    this.nextBtn?.addEventListener('click', () => this.slide('next'));
    this.track.addEventListener('touchstart', (e) => this.dragStart(e), { passive: true });
    this.track.addEventListener('touchmove', (e) => this.dragMove(e), { passive: true });
    this.track.addEventListener('touchend', () => this.dragEnd());
    window.addEventListener('resize', () => this.updateCarouselPosition());
  }
  initFilters() {
    this.filterBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        this.filterBtns.forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        const tag = btn.dataset.tag;
        this.filterCards(tag);
      });
    });
  }
  filterCards(tag) {
    this.cards.forEach(card => {
      const tags = card.dataset.tags || '';
      const slideParent = card.closest('.wosh-fbp__carrusel-slide');
      const targetEl = slideParent ? slideParent : card;
      if (tag === 'all' || tags.split(' ').includes(tag)) {
        targetEl.style.display = '';
        targetEl.style.opacity = '0';
        requestAnimationFrame(() => {
          targetEl.style.transition = 'opacity 0.4s ease, transform 0.4s ease';
          targetEl.style.opacity = '1';
        });
      } else {
        targetEl.style.display = 'none';
      }
    });
    if (this.carousel && this.track) {
      this.currentIndex = 0;
      this.updateCarouselPosition();
    }
  }
  slide(direction) {
    const visibleSlides = Array.from(this.slides).filter(slide => slide.style.display !== 'none');
    if (visibleSlides.length <= 1) return;
    const cardsPerView = window.innerWidth >= 749 ? parseInt(getComputedStyle(this).getPropertyValue('--columnas-desktop')) || 3 : 1;
    const maxIndex = Math.max(0, visibleSlides.length - cardsPerView);
    if (direction === 'next') {
      this.currentIndex = Math.min(this.currentIndex + 1, maxIndex);
    } else {
      this.currentIndex = Math.max(this.currentIndex - 1, 0);
    }
    this.updateCarouselPosition();
  }
  updateCarouselPosition() {
    const visibleSlides = Array.from(this.slides).filter(slide => slide.style.display !== 'none');
    if (visibleSlides.length === 0) {
      this.track.style.transform = 'translateX(0px)';
      return;
    }
    const gap = parseFloat(getComputedStyle(this).getPropertyValue('--gap-columnas')) || 24;
    const slideWidth = visibleSlides[0].getBoundingClientRect().width;
    const translateAmount = this.currentIndex * (slideWidth + gap);
    this.track.style.transform = `translateX(-${translateAmount}px)`;
  }
  dragStart(e) {
    this.isDragging = true;
    this.startX = e.touches[0].clientX;
    this.track.style.transition = 'none';
  }
  dragMove(e) {
    if (!this.isDragging) return;
    const currentX = e.touches[0].clientX;
    const diff = currentX - this.startX;
    const visibleSlides = Array.from(this.slides).filter(slide => slide.style.display !== 'none');
    if (visibleSlides.length === 0) return;
    const gap = parseFloat(getComputedStyle(this).getPropertyValue('--gap-columnas')) || 24;
    const slideWidth = visibleSlides[0].getBoundingClientRect().width;
    const baseTranslate = -this.currentIndex * (slideWidth + gap);
    this.track.style.transform = `translateX(${baseTranslate + diff}px)`;
  }
  dragEnd() {
    this.isDragging = false;
    this.track.style.transition = '';
    const visibleSlides = Array.from(this.slides).filter(slide => slide.style.display !== 'none');
    if (visibleSlides.length === 0) return;
    const gap = parseFloat(getComputedStyle(this).getPropertyValue('--gap-columnas')) || 24;
    const slideWidth = visibleSlides[0].getBoundingClientRect().width;
    const currentTransform = new WebKitCSSMatrix(getComputedStyle(this.track).transform).m41;
    const calculatedIndex = Math.round(-currentTransform / (slideWidth + gap));
    const cardsPerView = window.innerWidth >= 749 ? parseInt(getComputedStyle(this).getPropertyValue('--columnas-desktop')) || 3 : 1;
    const maxIndex = Math.max(0, visibleSlides.length - cardsPerView);
    this.currentIndex = Math.max(0, Math.min(calculatedIndex, maxIndex));
    this.updateCarouselPosition();
  }
}
if (!customElements.get('wosh-blog-posts')) {
  customElements.define('wosh-blog-posts', WoshBlogPosts);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product-information"] && !Shopify.designMode) return;
  try {
    
class WoshFeaturedProduct extends HTMLElement {
  constructor() {
    super();
    this.isMock = this.hasAttribute('data-mock');
    this.track = this.querySelector('.wosh-fpi__galeria-track');
    this.slides = this.querySelectorAll('.wosh-fpi__galeria-slide');
    this.thumbnails = this.querySelectorAll('.wosh-fpi__miniatura');
    this.prevBtn = this.querySelector('.wosh-fpi__galeria-btn--prev');
    this.nextBtn = this.querySelector('.wosh-fpi__galeria-btn--next');
    this.variantInputs = this.querySelectorAll('.wosh-fpi__variante-input');
    this.priceActual = this.querySelector('.wosh-fpi__precio-actual');
    this.priceAntiguo = this.querySelector('.wosh-fpi__precio-antiguo');
    this.variantIdInput = this.querySelector('.wosh-fpi__variant-id-hidden');
    this.buyBtn = this.querySelector('.wosh-fpi__add-btn');
    this.qtyInput = this.querySelector('.wosh-fpi__cantidad-input');
    this.qtyMinus = this.querySelector('.wosh-fpi__cantidad-btn--minus');
    this.qtyPlus = this.querySelector('.wosh-fpi__cantidad-btn--plus');
    this.formQuantityInput = this.querySelector('.wosh-fpi__form-qty-hidden');
    this.tabBtns = this.querySelectorAll('.wosh-fpi__tab-btn');
    this.tabPanels = this.querySelectorAll('.wosh-fpi__tab-panel');
    this.currentIndex = 0;
    this.variants = [];
    this.init();
  }
  init() {
    this.initCarousel();
    this.initQuantity();
    this.initTabs();
    this.initVariants();
    this.initCartAjax();
  }
  initCarousel() {
    if (this.slides.length <= 1) return;
    this.prevBtn?.addEventListener('click', () => this.slide('prev'));
    this.nextBtn?.addEventListener('click', () => this.slide('next'));
    this.thumbnails.forEach((thumb, i) => {
      thumb.addEventListener('click', () => this.goToSlide(i));
    });
  }
  goToSlide(index) {
    this.currentIndex = index;
    const offset = -this.currentIndex * 100;
    this.track.style.transform = `translateX(${offset}%)`;
    this.thumbnails.forEach(t => t.classList.remove('is-active'));
    this.thumbnails[this.currentIndex]?.classList.add('is-active');
  }
  slide(direction) {
    if (direction === 'next') {
      this.currentIndex = (this.currentIndex + 1) % this.slides.length;
    } else {
      this.currentIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
    }
    this.goToSlide(this.currentIndex);
  }
  initQuantity() {
    if (!this.qtyInput) return;
    this.qtyMinus?.addEventListener('click', () => this.adjustQty(-1));
    this.qtyPlus?.addEventListener('click', () => this.adjustQty(1));
  }
  adjustQty(val) {
    let current = parseInt(this.qtyInput.value) || 1;
    let next = Math.max(1, current + val);
    this.qtyInput.value = next;
    if (this.formQuantityInput) {
      this.formQuantityInput.value = next;
    }
  }
  initTabs() {
    this.tabBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const target = btn.dataset.tab;
        this.tabBtns.forEach(b => b.classList.remove('is-active'));
        this.tabPanels.forEach(p => p.classList.remove('is-active'));
        btn.classList.add('is-active');
        this.querySelector(`.wosh-fpi__tab-panel[data-panel="${target}"]`)?.classList.add('is-active');
      });
    });
  }
  initVariants() {
    if (this.isMock) {
      this.variants = [
        { id: 1, title: 'Negro / S', option1: 'Negro', option2: 'S', price: 11000, compare_at_price: 13000, available: true, image_index: 0 },
        { id: 2, title: 'Negro / M', option1: 'Negro', option2: 'M', price: 11000, compare_at_price: 13000, available: true, image_index: 0 },
        { id: 3, title: 'Negro / L', option1: 'Negro', option2: 'L', price: 11500, compare_at_price: 13000, available: false, image_index: 0 },
        { id: 4, title: 'Verde / S', option1: 'Verde', option2: 'S', price: 12000, compare_at_price: 14000, available: true, image_index: 1 },
        { id: 5, title: 'Verde / M', option1: 'Verde', option2: 'M', price: 12000, compare_at_price: 14000, available: true, image_index: 1 },
        { id: 6, title: 'Verde / L', option1: 'Verde', option2: 'L', price: 12500, compare_at_price: 14000, available: true, image_index: 1 },
        { id: 7, title: 'Naranja / S', option1: 'Naranja', option2: 'S', price: 13000, compare_at_price: 15000, available: true, image_index: 2 },
        { id: 8, title: 'Naranja / M', option1: 'Naranja', option2: 'M', price: 13000, compare_at_price: 15000, available: true, image_index: 2 },
        { id: 9, title: 'Naranja / L', option1: 'Naranja', option2: 'L', price: 13500, compare_at_price: 15000, available: true, image_index: 2 }
      ];
    } else {
      const script = this.querySelector('.wosh-fpi__variantes-json');
      if (script) {
        try {
          this.variants = JSON.parse(script.textContent);
        } catch(e) {}
      }
    }
    this.variantInputs.forEach(input => {
      input.addEventListener('change', () => this.updateVariantSelection());
    });
    this.updateVariantSelection();
  }
  updateVariantSelection() {
    const selectedOptions = {};
    const groups = this.querySelectorAll('.wosh-fpi__variante-grupo');
    groups.forEach((group, index) => {
      const checkedInput = group.querySelector('input:checked');
      if (checkedInput) {
        selectedOptions[`option${index + 1}`] = checkedInput.value;
      }
    });
    const variant = this.variants.find(v => {
      let match = true;
      if (selectedOptions['option1'] && v.option1 !== selectedOptions['option1']) match = false;
      if (selectedOptions['option2'] && v.option2 !== selectedOptions['option2']) match = false;
      if (selectedOptions['option3'] && v.option3 !== selectedOptions['option3']) match = false;
      return match;
    });
    if (variant) {
      if (this.variantIdInput) this.variantIdInput.value = variant.id;
      this.updatePrice(variant.price, variant.compare_at_price);
      this.updateBuyButton(variant.available);
      this.syncVariantImage(variant);
    } else {
      this.updateBuyButton(false, 'No disponible');
    }
  }
  updatePrice(price, comparePrice) {
    if (this.priceActual) {
      this.priceActual.innerHTML = this.formatMoney(price);
    }
    if (this.priceAntiguo) {
      if (comparePrice && comparePrice > price) {
        this.priceAntiguo.innerHTML = this.formatMoney(comparePrice);
        this.priceAntiguo.style.display = '';
      } else {
        this.priceAntiguo.style.display = 'none';
      }
    }
  }
  updateBuyButton(available, customText = null) {
    if (!this.buyBtn) return;
    if (available) {
      this.buyBtn.disabled = false;
      this.buyBtn.innerHTML = this.buyBtn.dataset.originalText || 'Agregar al carrito';
    } else {
      this.buyBtn.disabled = true;
      this.buyBtn.innerHTML = customText || 'Agotado';
    }
  }
  syncVariantImage(variant) {
    if (this.isMock) {
      if (typeof variant.image_index !== 'undefined') {
        this.goToSlide(variant.image_index);
      }
    } else {
      if (variant.featured_image && variant.featured_image.id) {
        const slideIndex = Array.from(this.slides).findIndex(s => s.dataset.imageId == variant.featured_image.id);
        if (slideIndex !== -1) {
          this.goToSlide(slideIndex);
        }
      }
    }
  }
  formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }
  initCartAjax() {
    this.addEventListener('submit', (e) => {
      if (e.target.classList.contains('wosh-fpi__form')) {
        e.preventDefault();
        const form = e.target;
        const btn = this.buyBtn;
        if (!btn) return;
        
        const originalText = btn.innerHTML;
        btn.disabled = true;
        btn.innerHTML = 'Agregando...';
        
        const formData = new FormData(form);
        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(response => response.json())
        .then(data => {
          // Eliminamos cualquier evento custom que no funciona en todos los temas
          // y redirigimos directamente al carrito para dar una confirmación inmediata real
          window.location.href = '/cart';
        })
        .catch(() => {
          btn.innerHTML = 'Error';
          setTimeout(() => {
            btn.innerHTML = originalText;
            btn.disabled = false;
          }, 2000);
        });
      }
    });
  }
}
if (!customElements.get('wosh-featured-product')) {
  customElements.define('wosh-featured-product', WoshFeaturedProduct);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initHeroSlider(section) {
    const carrusel = section.querySelector('.hp-hero-carrusel');
    if (!carrusel) return;
    const diapositivas = section.querySelectorAll('.hp-hero-diapositiva');
    const puntos = section.querySelectorAll('.hp-hero-punto');
    const prevBtn = section.querySelector('.hp-hero-flecha-prev');
    const nextBtn = section.querySelector('.hp-hero-flecha-next');
    if (diapositivas.length <= 1) return;

    let indexActivo = 0;
    const autoplay = section.dataset.autoplay === 'true';
    const intervalTime = parseInt(section.dataset.autoplayInterval, 10) * 1000 || 5000;
    let autoplayTimer = null;

    function irADiapositiva(idx) {
      if (idx < 0) idx = diapositivas.length - 1;
      if (idx >= diapositivas.length) idx = 0;
      indexActivo = idx;
      
      const slideOffset = diapositivas[idx].offsetLeft;
      carrusel.scrollTo({
        left: slideOffset,
        behavior: 'smooth'
      });
      
      puntos.forEach((p, i) => {
        if (i === idx) {
          p.classList.add('hp-activo');
        } else {
          p.classList.remove('hp-activo');
        }
      });
    }

    function siguiente() {
      irADiapositiva(indexActivo + 1);
    }

    function anterior() {
      irADiapositiva(indexActivo - 1);
    }

    function iniciarAutoplay() {
      if (autoplay) {
        detenerAutoplay();
        autoplayTimer = setInterval(siguiente, intervalTime);
      }
    }

    function detenerAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        anterior();
        iniciarAutoplay();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        siguiente();
        iniciarAutoplay();
      });
    }

    puntos.forEach((punto, idx) => {
      punto.addEventListener('click', function() {
        irADiapositiva(idx);
        iniciarAutoplay();
      });
    });

    carrusel.addEventListener('scroll', function() {
      const scrollPos = carrusel.scrollLeft;
      const width = carrusel.clientWidth;
      const newIdx = Math.round(scrollPos / width);
      if (newIdx !== indexActivo && newIdx >= 0 && newIdx < diapositivas.length) {
        indexActivo = newIdx;
        puntos.forEach((p, i) => {
          if (i === newIdx) {
            p.classList.add('hp-activo');
          } else {
            p.classList.remove('hp-activo');
          }
        });
      }
    });

    iniciarAutoplay();

    carrusel.addEventListener('mouseenter', detenerAutoplay);
    carrusel.addEventListener('mouseleave', iniciarAutoplay);
    carrusel.addEventListener('touchstart', detenerAutoplay, {passive: true});
    carrusel.addEventListener('touchend', iniciarAutoplay, {passive: true});

    document.addEventListener('shopify:block:select', function(e) {
      if (e.target.closest('#Hero-' + section.dataset.sectionId)) {
        const blockId = e.detail.blockId;
        const targetSlide = section.querySelector('[data-block-id="' + blockId + '"]');
        if (targetSlide) {
          const idx = Array.from(diapositivas).indexOf(targetSlide);
          if (idx !== -1) {
            detenerAutoplay();
            irADiapositiva(idx);
          }
        }
      }
    });

    document.addEventListener('shopify:block:deselect', function(e) {
      if (e.target.closest('#Hero-' + section.dataset.sectionId)) {
        iniciarAutoplay();
      }
    });
  }

  function initAllSliders() {
    document.querySelectorAll('.hp-hero-seccion').forEach(function(section) {
      initHeroSlider(section);
    });
  }

  document.addEventListener('DOMContentLoaded', initAllSliders);
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initAllSliders);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["layered-slideshow"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initSlideshow(section) {
    const contenedor = section.querySelector('.sl-slideshow-contenedor');
    if (!contenedor) return;
    const diapositivas = section.querySelectorAll('.sl-diapositiva');
    const puntos = section.querySelectorAll('.sl-punto');
    const prevBtn = section.querySelector('.sl-flecha-prev');
    const nextBtn = section.querySelector('.sl-flecha-next');
    if (diapositivas.length === 0) return;

    let indexActivo = 0;
    const autoplay = section.dataset.autoplay === 'true';
    const intervalTime = parseInt(section.dataset.autoplayInterval, 10) * 1000 || 5000;
    let autoplayTimer = null;

    function mostrarDiapositiva(idx) {
      if (idx < 0) idx = diapositivas.length - 1;
      if (idx >= diapositivas.length) idx = 0;
      
      diapositivas[indexActivo].classList.remove('sl-activo');
      puntos[indexActivo]?.classList.remove('sl-activo');
      
      diapositivas[idx].classList.add('sl-activo');
      puntos[idx]?.classList.add('sl-activo');
      
      indexActivo = idx;
    }

    function siguiente() {
      mostrarDiapositiva(indexActivo + 1);
    }

    function anterior() {
      mostrarDiapositiva(indexActivo - 1);
    }

    function iniciarAutoplay() {
      if (autoplay && diapositivas.length > 1) {
        detenerAutoplay();
        autoplayTimer = setInterval(siguiente, intervalTime);
      }
    }

    function detenerAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        anterior();
        iniciarAutoplay();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        siguiente();
        iniciarAutoplay();
      });
    }

    puntos.forEach((punto, idx) => {
      punto.addEventListener('click', function() {
        mostrarDiapositiva(idx);
        iniciarAutoplay();
      });
    });

    iniciarAutoplay();

    contenedor.addEventListener('mouseenter', detenerAutoplay);
    contenedor.addEventListener('mouseleave', iniciarAutoplay);
    contenedor.addEventListener('touchstart', detenerAutoplay, {passive: true});
    contenedor.addEventListener('touchend', iniciarAutoplay, {passive: true});

    document.addEventListener('shopify:block:select', function(e) {
      if (e.target.closest('#Slideshow-' + section.dataset.sectionId)) {
        const blockId = e.detail.blockId;
        const targetSlide = section.querySelector('[data-block-id="' + blockId + '"]');
        if (targetSlide) {
          const idx = Array.from(diapositivas).indexOf(targetSlide);
          if (idx !== -1) {
            detenerAutoplay();
            mostrarDiapositiva(idx);
          }
        }
      }
    });

    document.addEventListener('shopify:block:deselect', function(e) {
      if (e.target.closest('#Slideshow-' + section.dataset.sectionId)) {
        iniciarAutoplay();
      }
    });
  }

  function initAllSlideshows() {
    document.querySelectorAll('.sl-slideshow-seccion').forEach(function(section) {
      initSlideshow(section);
    });
  }

  document.addEventListener('DOMContentLoaded', initAllSlideshows);
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initAllSlideshows);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }
  document.addEventListener('click', function(e) {
    if (e.target && e.target.classList.contains('ml-quick-add-btn')) {
      const variantId = e.target.getAttribute('data-variant-id');
      if (!variantId) return;
      e.preventDefault();
      e.stopPropagation();
      const originalText = e.target.innerText;
      e.target.disabled = true;
      e.target.innerText = '...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: parseInt(variantId, 10),
          quantity: 1
        })
      })
      .then(response => {
        if (!response.ok) throw new Error('Error');
        return response.json();
      })
      .then(data => {
        window.location.reload();
      })
      .catch(err => {
        e.target.disabled = false;
        e.target.innerText = originalText;
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-with-content"] && !Shopify.designMode) return;
  try {
    
class WoshMediaContent extends HTMLElement {
  constructor() {
    super();
    this.items = this.querySelectorAll('.wosh-mwc__fila');
  }
  connectedCallback() {
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-active');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });
      this.items.forEach(item => observer.observe(item));
    } else {
      this.items.forEach(item => item.classList.add('is-active'));
    }
  }
}
if (!customElements.get('wosh-media-content')) {
  customElements.define('wosh-media-content', WoshMediaContent);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wosh-cart"] && !Shopify.designMode) return;
  try {
    
class WoshCart extends HTMLElement {
  constructor() {
    super();
    this.section = this;
    this.buttons = this.querySelectorAll('.wosh-cart__cant-btn');
    this.removeLinks = this.querySelectorAll('.wosh-cart__remover');
    this.init();
  }

  init() {
    this.buttons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const action = btn.dataset.action;
        const key = btn.dataset.key;
        const input = this.querySelector(`.wosh-cart__cant-input[data-key="${key}"]`);
        let currentVal = parseInt(input.value);
        let newVal = action === 'plus' ? currentVal + 1 : currentVal - 1;
        if(newVal < 0) newVal = 0;
        
        this.updateCart(key, newVal);
      });
    });

    this.removeLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const key = link.dataset.key;
        this.updateCart(key, 0);
      });
    });
  }

  updateCart(key, quantity) {
    this.section.classList.add('is-loading');
    
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: key,
        quantity: quantity
      })
    })
    .then(response => response.json())
    .then(data => {
      // Reload page to reflect changes cleanly without complex DOM diffing
      window.location.reload();
    })
    .catch(error => {
      console.error('Error updating cart:', error);
      this.section.classList.remove('is-loading');
    });
  }
}

if (!customElements.get('wosh-cart')) {
  customElements.define('wosh-cart', WoshCart);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wosh-faq"] && !Shopify.designMode) return;
  try {
    
function initFaqWosh() {
  var secciones = document.querySelectorAll('.faq-seccion');
  secciones.forEach(function (seccion) {
    if (seccion.dataset.inicializado) return;
    seccion.dataset.inicializado = 'true';

    var botones = seccion.querySelectorAll('.faq-seccion__pregunta');

    botones.forEach(function (boton) {
      boton.addEventListener('click', function () {
        var item = boton.closest('.faq-seccion__item');
        var estaAbierto = item.classList.contains('faq-seccion__item--activo');

        botones.forEach(function (otro) {
          otro.closest('.faq-seccion__item').classList.remove('faq-seccion__item--activo');
          otro.setAttribute('aria-expanded', 'false');
        });

        if (!estaAbierto) {
          item.classList.add('faq-seccion__item--activo');
          boton.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', initFaqWosh);
document.addEventListener('shopify:section:load', initFaqWosh);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wosh-featured-collection"] && !Shopify.designMode) return;
  try {
    
class WoshFeaturedCollection extends HTMLElement {
  constructor() {
    super();
    this.carrusel = this.querySelector('.wosh-fc__carrusel');
    this.btnPrev = this.querySelector('.wosh-fc__flecha--prev');
    this.btnNext = this.querySelector('.wosh-fc__flecha--next');
    
    if (this.btnPrev && this.btnNext && this.carrusel) {
      this.btnPrev.addEventListener('click', () => this.scroll(-1));
      this.btnNext.addEventListener('click', () => this.scroll(1));
    }
  }

  scroll(direction) {
    const scrollAmount = this.carrusel.clientWidth * 0.8;
    this.carrusel.scrollBy({
      left: scrollAmount * direction,
      behavior: 'smooth'
    });
  }
}

if (!customElements.get('wosh-featured-collection')) {
  customElements.define('wosh-featured-collection', WoshFeaturedCollection);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wosh-featured-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // Gallery Thumbnails
    const thumbnails = document.querySelectorAll('.wosh-featured-product__thumb');
    if (thumbnails.length > 0) {
      thumbnails.forEach(thumb => {
        thumb.addEventListener('click', function() {
          const mainImage = this.closest('.wosh-featured-product__card').querySelector('.wosh-featured-product__main-image');
          thumbnails.forEach(t => t.classList.remove('is-active'));
          this.classList.add('is-active');
          mainImage.src = this.getAttribute('data-target-img');
        });
      });
    }

    // Variant Selection Update Image & Price
    const variantSelects = document.querySelectorAll('.wosh-featured-product__variant-select');
    variantSelects.forEach(select => {
      select.addEventListener('change', function() {
        const option = this.options[this.selectedIndex];
        const card = this.closest('.wosh-featured-product__card');
        
        // Update price
        const priceEl = card.querySelector('.wosh-featured-product__price-regular');
        if(priceEl) priceEl.textContent = option.getAttribute('data-price');
        
        // Update image if variant has one
        const newImage = option.getAttribute('data-image');
        if(newImage) {
          const mainImage = card.querySelector('.wosh-featured-product__main-image');
          if(mainImage) mainImage.src = newImage;
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wosh-hero-slider"] && !Shopify.designMode) return;
  try {
    
class WoshHeroSlider extends HTMLElement {
  constructor() {
    super();
    this.track = this.querySelector('.wosh-hero-slider__track');
    this.slides = this.querySelectorAll('.wosh-hero-slider__slide');
    this.dots = this.querySelectorAll('.wosh-hero-slider__dot');
    this.fondoEl = this.querySelector('.wosh-hero-slider__fondo-seccion');

    if (this.slides.length === 0) return;

    this.updateSliderHeight(this.slides[0]);
    this.updateBackground(this.slides[0]);

    if (this.slides.length < 2) return;

    this.autoplaySpeed = parseFloat(getComputedStyle(this).getPropertyValue('--autoplay-speed')) * 1000 || 6000;
    this.currentIndex = 0;
    this.timer = null;
    this.isDragging = false;
    this.startX = 0;

    this.init();
  }

  init() {
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        this.goToSlide(index);
        this.resetTimer();
      });
    });

    document.addEventListener('shopify:block:select', (e) => {
      if (!this.contains(e.target)) return;
      const target = Array.from(this.slides).find(s => s.contains(e.target));
      if (target) {
        this.goToSlide(parseInt(target.dataset.index));
        this.pause();
      }
    });

    document.addEventListener('shopify:block:deselect', (e) => {
      if (!this.contains(e.target)) return;
      this.play();
    });

    this.track.addEventListener('touchstart', (e) => {
      this.startX = e.touches[0].clientX;
      this.isDragging = true;
      this.pause();
    }, { passive: true });

    this.track.addEventListener('touchend', (e) => {
      if (!this.isDragging) return;
      const diff = this.startX - e.changedTouches[0].clientX;
      if (diff > 50) {
        this.goToSlide((this.currentIndex + 1) % this.slides.length);
      } else if (diff < -50) {
        this.goToSlide((this.currentIndex - 1 + this.slides.length) % this.slides.length);
      }
      this.play();
      this.isDragging = false;
    });

    this.addEventListener('mouseenter', () => this.pause());
    this.addEventListener('mouseleave', () => this.play());

    requestAnimationFrame(() => {
      if (this.dots[this.currentIndex]) {
        this.dots[this.currentIndex].querySelector('.wosh-hero-slider__dot-progress').classList.add('is-animating');
      }
    });

    this.play();

    // Fix for theme's sticky header calculation on load
    window.addEventListener('load', () => {
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 100);
    });
  }

  updateBackground(slide) {
    if (!this.fondoEl || !slide) return;
    const c1 = slide.dataset.color1 || '#0B2E23';
    const c2 = slide.dataset.color2 || c1;
    const angulo = slide.dataset.angulo || '120';
    this.fondoEl.style.background = `linear-gradient(${angulo}deg, ${c1} 0%, ${c2} 100%)`;
  }

  updateSliderHeight(slide) {
    if (slide.classList.contains('wosh-hero-slider__slide--banner')) {
      this.classList.add('has-active-banner');
    } else {
      this.classList.remove('has-active-banner');
    }
  }

  goToSlide(index) {
    this.slides[this.currentIndex].classList.remove('is-active');
    this.dots[this.currentIndex].classList.remove('is-active');

    const oldProgress = this.dots[this.currentIndex].querySelector('.wosh-hero-slider__dot-progress');
    oldProgress.classList.remove('is-animating');

    this.currentIndex = index;

    this.slides[this.currentIndex].classList.add('is-active');
    this.dots[this.currentIndex].classList.add('is-active');

    this.updateBackground(this.slides[this.currentIndex]);
    this.updateSliderHeight(this.slides[this.currentIndex]);

    const newProgress = this.dots[this.currentIndex].querySelector('.wosh-hero-slider__dot-progress');
    void newProgress.offsetWidth;
    newProgress.classList.add('is-animating');

    this.track.style.transform = `translateX(-${this.currentIndex * 100}%)`;
  }

  play() {
    this.resetTimer();
    if (this.dots[this.currentIndex]) {
      this.dots[this.currentIndex].querySelector('.wosh-hero-slider__dot-progress').classList.add('is-animating');
    }
  }

  pause() {
    clearInterval(this.timer);
    if (this.dots[this.currentIndex]) {
      this.dots[this.currentIndex].querySelector('.wosh-hero-slider__dot-progress').classList.remove('is-animating');
    }
  }

  resetTimer() {
    clearInterval(this.timer);
    this.timer = setInterval(() => {
      this.goToSlide((this.currentIndex + 1) % this.slides.length);
    }, this.autoplaySpeed);
  }
}

if (!customElements.get('wosh-hero-slider')) {
  customElements.define('wosh-hero-slider', WoshHeroSlider);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wosh-image-compare"] && !Shopify.designMode) return;
  try {
    
function initComparadorWosh() {
  var rangos = document.querySelectorAll('.comparador-seccion__rango');
  rangos.forEach(function(rango) {
    if (rango.dataset.inicializado) return;
    rango.dataset.inicializado = 'true';

    rango.addEventListener('input', function(e) {
      var contenedor = e.target.closest('[data-comparador-contenedor]');
      if (contenedor) {
        contenedor.style.setProperty('--exposure', e.target.value + '%');
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', initComparadorWosh);
document.addEventListener('shopify:section:load', initComparadorWosh);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wosh-main-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // Gallery Thumbnails
    const thumbnails = document.querySelectorAll('.wosh-main-product__thumb');
    if (thumbnails.length > 0) {
      thumbnails.forEach(thumb => {
        thumb.addEventListener('click', function() {
          const mainImage = this.closest('.wosh-main-product__media').querySelector('.wosh-main-product__main-image');
          thumbnails.forEach(t => t.classList.remove('is-active'));
          this.classList.add('is-active');
          mainImage.src = this.getAttribute('data-target-img');
        });
      });
    }

    // Lightbox (Zoom)
    const zoomTrigger = document.querySelector('.wosh-main-product__main-image-container');
    const lightbox = document.querySelector('.wosh-main-product__lightbox');
    if (zoomTrigger && lightbox) {
      const closeBtn = lightbox.querySelector('.wosh-main-product__lightbox-close');
      const lightboxImg = lightbox.querySelector('.wosh-main-product__lightbox-img');
      const mainImage = zoomTrigger.querySelector('.wosh-main-product__main-image');

      zoomTrigger.addEventListener('click', () => {
        lightboxImg.src = mainImage.src;
        lightbox.classList.add('is-active');
      });

      closeBtn.addEventListener('click', () => {
        lightbox.classList.remove('is-active');
      });

      lightbox.addEventListener('click', (e) => {
        if(e.target === lightbox) lightbox.classList.remove('is-active');
      });
    }

    // Variant Selection Update Image, Price, Stock, URL
    const variantSelects = document.querySelectorAll('.wosh-main-product__variant-select');
    variantSelects.forEach(select => {
      select.addEventListener('change', function() {
        const option = this.options[this.selectedIndex];
        const card = this.closest('.wosh-main-product-section');
        const variantId = option.value;
        const available = option.getAttribute('data-available') === 'true';
        
        // Update URL
        const url = new URL(window.location);
        url.searchParams.set('variant', variantId);
        window.history.replaceState({}, '', url);

        // Update price with promo logic
        const priceBox = card.querySelector('.wosh-main-product__price-box');
        const promoActiva = priceBox?.dataset.promoActiva === 'true';
        const promoPorcentaje = parseInt(priceBox?.dataset.promoPorcentaje || '20');
        const priceEl = card.querySelector('.wosh-main-product__price-regular');
        const compareEl = card.querySelector('.wosh-main-product__price-compare');
        const badgeEl = card.querySelector('.wosh-main-product__promo-badge');
        const priceRaw = parseInt(option.getAttribute('data-price-raw') || '0');
        const compareRaw = parseInt(option.getAttribute('data-compare-raw') || '0');
        const hasRealDiscount = compareRaw > priceRaw;

        if (hasRealDiscount) {
          if (compareEl) { compareEl.textContent = option.getAttribute('data-compare'); compareEl.style.display = ''; }
          if (priceEl) priceEl.textContent = option.getAttribute('data-price');
          if (badgeEl) {
            const d = Math.round((compareRaw - priceRaw) * 100 / compareRaw);
            badgeEl.textContent = `-${d}%`;
            badgeEl.style.display = '';
          }
        } else if (promoActiva) {
          if (compareEl) { compareEl.textContent = option.getAttribute('data-price'); compareEl.style.display = ''; }
          if (priceEl) priceEl.textContent = option.getAttribute('data-price-promo');
          if (badgeEl) { badgeEl.textContent = `-${promoPorcentaje}%`; badgeEl.style.display = ''; }
        } else {
          if (priceEl) priceEl.textContent = option.getAttribute('data-price');
          if (compareEl) compareEl.style.display = 'none';
          if (badgeEl) badgeEl.style.display = 'none';
        }
        
        // Update stock & buttons
        const stockEl = card.querySelector('.wosh-main-product__stock');
        const addBtn = card.querySelector('.wosh-main-product__btn-add');
        if (available) {
          if(stockEl) {
             stockEl.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg> En stock';
             stockEl.classList.remove('out-of-stock');
          }
          if(addBtn) {
             addBtn.disabled = false;
             addBtn.textContent = 'Añadir al carrito';
          }
        } else {
          if(stockEl) {
             stockEl.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg> Agotado';
             stockEl.classList.add('out-of-stock');
          }
          if(addBtn) {
             addBtn.disabled = true;
             addBtn.textContent = 'Agotado';
          }
        }

        // Update image if variant has one
        const newImage = option.getAttribute('data-image');
        if(newImage) {
          const mainImage = card.querySelector('.wosh-main-product__main-image');
          if(mainImage) mainImage.src = newImage;
          
          // match thumbnail
          const thumbMatch = card.querySelector(`.wosh-main-product__thumb[data-target-img="${newImage}"]`);
          if (thumbMatch) {
             const allThumbs = card.querySelectorAll('.wosh-main-product__thumb');
             allThumbs.forEach(t => t.classList.remove('is-active'));
             thumbMatch.classList.add('is-active');
          }
        }
      });
    });

    // AJAX ADD TO CART
    const forms = document.querySelectorAll('.wosh-main-product__form');
    forms.forEach(form => {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        const addBtn = form.querySelector('[name="add"]');
        if(addBtn) {
          addBtn.disabled = true;
          addBtn.textContent = 'Agregando...';
        }

        const cartItemsComponents = document.querySelectorAll('cart-items-component, cart-drawer');
        const sectionsToUpdate = [];
        cartItemsComponents.forEach(item => {
           if (item.dataset.sectionId && !sectionsToUpdate.includes(item.dataset.sectionId)) {
             sectionsToUpdate.push(item.dataset.sectionId);
           }
        });

        const formData = new FormData(form);
        const data = {
          items: [{
            id: formData.get('id'),
            quantity: formData.get('quantity') || 1
          }],
          sections: sectionsToUpdate.join(',')
        };

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(data)
        })
        .then(response => response.json())
        .then(data => {
          // Dispatch exactly what the theme expects for CartAddEvent
          document.dispatchEvent(new CustomEvent('cart:update', { 
            bubbles: true, 
            detail: { 
              resource: data,
              sourceId: form.id,
              data: {
                source: 'product-form-component',
                sections: data.sections || {}
              }
            } 
          }));
          
          // Try theme-specific cart triggers
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) {
             cartDrawer.classList.add('is-active');
             document.body.classList.add('overflow-hidden');
          }

          // Trigger standard Shopify click on header cart icon as fallback if no drawer
          const cartIcon = document.querySelector('.header__icon--cart');
          if (cartIcon && !cartDrawer) {
            cartIcon.click();
          }
        })
        .catch(err => {
          console.error(err);
          form.submit(); 
        })
        .finally(() => {
          if(addBtn) {
            addBtn.disabled = false;
            addBtn.textContent = 'Añadir al carrito';
          }
        });
      });
    });

    // BUY NOW
    const buyNowBtns = document.querySelectorAll('.wosh-main-product__btn-buy');
    buyNowBtns.forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        const form = this.closest('form');
        const formData = new FormData(form);
        const data = {
          items: [{
            id: formData.get('id'),
            quantity: formData.get('quantity') || 1
          }]
        };
        
        this.disabled = true;
        this.textContent = 'Procesando...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(data)
        })
        .then(() => {
          window.location.href = '/checkout';
        })
        .catch(() => {
          window.location.href = '/checkout';
        });
      });
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wosh-product-recommendations"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const recommendationsSection = document.querySelector('.wosh-recommendations');
    if (!recommendationsSection) return;

    fetch(recommendationsSection.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.wosh-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          recommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error('Error fetching recommendations', e);
      });
  });

  } catch(e) { console.error(e); }
})();
})();
